import { notificationsActionTypes } from '@/components/notifications/Constants';

import type { NotificationsData } from '@/components/notifications/types';

export interface ToggleNotificationsMenuAction {
	type: typeof notificationsActionTypes.TOGGLE_NOTIFICATIONS_MENU;
	payload: {
		status: boolean;
	};
}

export interface GetNotificationsRequestAction {
	type: typeof notificationsActionTypes.GET_NOTIFICATIONS_REQUEST;
}

export interface GetNotificationsSuccessAction {
	type: typeof notificationsActionTypes.GET_NOTIFICATIONS_SUCCESS;
	payload: {
		notificationsData: NotificationsData;
	};
}

export interface GetNotificationsErrorAction {
	type: typeof notificationsActionTypes.GET_NOTIFICATIONS_ERROR;
}

export interface UpdateNotificationStatusRequestAction {
	type: typeof notificationsActionTypes.UPDATE_NOTIFICATION_STATUS_REQUEST;
	payload: {
		notificationId: string | number;
	};
}

export interface UpdateNotificationStatusErrorAction {
	type: typeof notificationsActionTypes.UPDATE_NOTIFICATION_STATUS_ERROR;
}

export type NotificationsAction =
	| ToggleNotificationsMenuAction
	| GetNotificationsRequestAction
	| GetNotificationsSuccessAction
	| GetNotificationsErrorAction
	| UpdateNotificationStatusRequestAction
	| UpdateNotificationStatusErrorAction;

export function toggleNotificationsMenu(status: boolean): ToggleNotificationsMenuAction {
	return {
		type: notificationsActionTypes.TOGGLE_NOTIFICATIONS_MENU,
		payload: {
			status,
		},
	};
}

export function getNotificationsRequest(): GetNotificationsRequestAction {
	return {
		type: notificationsActionTypes.GET_NOTIFICATIONS_REQUEST,
	};
}

export function getNotificationsSuccess(
	notificationsData: NotificationsData,
): GetNotificationsSuccessAction {
	return {
		type: notificationsActionTypes.GET_NOTIFICATIONS_SUCCESS,
		payload: {
			notificationsData,
		},
	};
}

export function getNotificationsError(): GetNotificationsErrorAction {
	return {
		type: notificationsActionTypes.GET_NOTIFICATIONS_ERROR,
	};
}

export function updateNotificationStatusRequest(
	notificationId: string | number,
): UpdateNotificationStatusRequestAction {
	return {
		type: notificationsActionTypes.UPDATE_NOTIFICATION_STATUS_REQUEST,
		payload: {
			notificationId,
		},
	};
}

export function updateNotificationStatusError(): UpdateNotificationStatusErrorAction {
	return {
		type: notificationsActionTypes.UPDATE_NOTIFICATION_STATUS_ERROR,
	};
}
